import * as NavigationMenuPrimitive from "@radix-ui/react-navigation-menu";
import { ChevronDown } from "lucide-react";
import { forwardRef } from "react";

import {
  NAVIGATION_MENU_TRIGGER_CLASS,
  type TNavigationMenuTriggerElement,
  type TNavigationMenuTriggerProps,
} from "@/ui/components/navigation/NavigationMenu/NavigationMenu.config";
import { cn } from "@/ui/lib/utils";

export const navigationMenuTriggerStyle = () => NAVIGATION_MENU_TRIGGER_CLASS;

export const NavigationMenuTrigger = forwardRef<
  TNavigationMenuTriggerElement,
  TNavigationMenuTriggerProps
>(({ children, className, ...props }, ref) => (
  <NavigationMenuPrimitive.Trigger
    ref={ref}
    data-component="NavigationMenuTrigger"
    className={cn(navigationMenuTriggerStyle(), className)}
    {...props}
  >
    { children }
    <ChevronDown
      aria-hidden="true"
      className="relative top-px ml-1 h-3 w-3 transition duration-300 group-data-[state=open]:rotate-180"
    />
  </NavigationMenuPrimitive.Trigger>
));

NavigationMenuTrigger.displayName = NavigationMenuPrimitive.Trigger.displayName;
